export default {
  title: 'Note importanti',
  buttons: {
    add_note: 'Aggiungi nota',
  },
};
